import React from 'react';
import { api } from '../../data/api';
import { ILatestVerificationState } from '../../data/entities/booking-state';
import { useDataLoad } from '../../view/helpers/hooks';

export const loadLatestVerification = (propertyId: number | string, eventId: string) => {
	const [latestVerification, setLatestVerification] = React.useState<ILatestVerificationState | null>(null);
	const loadingLatestVerification = useDataLoad(
		!latestVerification,
		() => api.bookingStateLatestVerification.getStateEventLatestVerificationByEventId(propertyId, eventId)
			.catch(() => setLatestVerification(null))
			.then((resp: ILatestVerificationState) => setLatestVerification(resp))
	);
	return { loadingLatestVerification, latestVerification };
};
